import { FieldLevelError } from '@/root/shared-errors'
import type { Key } from '@/root/shared-hooks/useGetTranslations/useGetTranslations'

const TRANSLATIONS: Record<string, Key> = {
  DISCOUNT_ALREADY_USED_IN_RESERVATION: 'discountAlreadyUsedInReservation',
  DISCOUNT_ALREADY_USED_ON_SAIL: 'discountAlreadyUsedOnSail',
  NO_DISCOUNT_ON_ROUTE: 'NO_DISCOUNT_ON_ROUTE',
  INVALID_PERSONAL_IDENTIFICATION_NUMBER: 'INVALID_PERSONAL_IDENTIFICATION_NUMBER',
}

export const throwResidentDiscountError = (getTranslation: (key: Key) => string, apiCode?: string): void => {
  const translationKey = apiCode ? TRANSLATIONS[apiCode] : undefined
  if (translationKey) {
    throw new FieldLevelError(getTranslation(translationKey))
  }
}
